<template>
    <div>
      <component :is="layout">
        <router-view :key="$route.fullPath"></router-view>
      </component>
    </div>
</template>

<script>
import { mapState } from 'vuex'

const defaultLayout = 'guest'
export default {
  computed: {
    ...mapState({
      layout () {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    })
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue